import { forwardRef } from 'react';

import type { BaseStatusChipProps } from '../base-status-chip';
import { BaseStatusChip } from '../base-status-chip';

export type StatusChipProps = Omit<BaseStatusChipProps, 'hideIcon'>;

export const CustomChip = forwardRef<HTMLDivElement, StatusChipProps>(
  (props: StatusChipProps, ref) => {
    return <BaseStatusChip ref={ref} {...props} hideIcon />;
  },
);
